import { useDroppable } from '@dnd-kit/core';
import styled, { css, keyframes } from 'styled-components';

const S = {
  Content: styled.div<{ $over: boolean }>`
    ${({ $over }) => css`
      border: 0.2rem dashed #54B4D3;
      border-radius: 0.4rem;
      padding: 0.1rem 0.8rem;
      animation: ${$over
        ? css`
            ${keyframes`
              0% {
                padding: 0.1rem 0.5rem;
                background-color: none;
              }
              100% {
                padding: 0.1rem 1.1rem;
                background-color:rgb(255, 255, 255);
              }
            `} 0.1s forwards
          `
        : css`
            ${keyframes`
              0% {
                padding: 0.1rem 1.1rem;
                background-color: rgb(255, 255, 255);
              }
              100% {
                padding: 0.1rem 0.5rem;
                background-color: none;
              }
            `} 0.15s forwards
          `};
    `}
  `,
};

export const CurrentTagContent = ({ children }: { children: React.ReactNode }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: 'current-tag-content',
  });

  return (
    <S.Content ref={setNodeRef} $over={isOver}>
      {children}
    </S.Content>
  );
};
